var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.683 11.728 9.801 2.022a2.098 2.098 0 0 0-3.602 0L.317 11.728C-.55 13.158.464 15 2.117 15h11.765c1.654 0 2.668-1.842 1.801-3.272ZM8 4.5c-.442 0-.8.366-.8.817v3.47c0 .452.358.817.8.817.442 0 .8-.365.8-.816V5.316A.808.808 0 0 0 8 4.5Zm.8 7.35a.809.809 0 0 1-.8.817.809.809 0 0 1-.8-.817c0-.451.358-.817.8-.817.442 0 .8.366.8.817Z",
    fill: "currentColor"
  })));
};

export default SvgWarningIcon;